import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=6bd8068d&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"
import style0 from "./faq.css?vue&type=style&index=0&id=6bd8068d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd8068d",
  null
  
)

export default component.exports